import { PATH_PAYROLLS, PATH_ROOT } from "@/constants";
import { BreadcrumbItem } from "@/types/breadcrumb";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const usePayrollBreadcrumbs = (
  additionalItems?: (BreadcrumbItem | undefined)[],
) => {
  const { t } = useTranslation();

  return useMemo(() => {
    const breadcrumbItems: BreadcrumbItem[] = [
      { label: t("breadcrumb.home"), href: PATH_ROOT },
      { label: t("payrolls.breadcrumb.payrolls"), href: PATH_PAYROLLS },
    ];

    if (additionalItems && additionalItems.length > 0) {
      breadcrumbItems.push(...additionalItems.filter((item) => !!item));
    }

    return breadcrumbItems;
  }, [t, additionalItems]);
};
